import { SeatBoardLayout } from './SeatBoardLayout';
import { SeatLabel, isSeat } from './SeatLabel';
import { VulnerabilityBoard } from './VulnerabilityBoard';
import { HandDisplay } from '../problems/HandDisplay';
import type { Position } from '../../types/problems';

/**
 * The left panel of the table: "You hold — <seat>", the thirteen cards, and the vulnerability
 * board, laid out on the side that matches the seat so the two read as one picture of where the
 * learner is sitting.
 *
 * Identical in every table session — a hand is a hand whatever the session's rules are — so this
 * is the whole panel, not a set of slots.
 */
export function HandPanel({
  seat,
  hand,
  vulnerability,
  dealer,
}: {
  /** The seat the learner is bidding from ("N" | "E" | "S" | "W"). */
  seat: string;
  hand: { spades: string; hearts: string; diamonds: string; clubs: string };
  vulnerability: string;
  dealer?: string;
}) {
  return (
    <SeatBoardLayout
      seat={seat}
      handLabel={
        <>
          You hold — <SeatLabel seat={seat} letterOnTabletPortrait />
        </>
      }
      hand={
        <HandDisplay
          hand={{
            spades: hand.spades,
            hearts: hand.hearts,
            diamonds: hand.diamonds,
            clubs: hand.clubs,
          }}
        />
      }
      board={
        <VulnerabilityBoard
          vulnerability={vulnerability}
          decisionSeat={seat as Position}
          dealer={isSeat(dealer) ? dealer : undefined}
        />
      }
    />
  );
}
